// App.jsx  ⟶  replace everything with this
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./components/Home";
import Pricing from "./components/Pricing";
import SignIn from "./components/SignIn";        // uses <GoogleLogin /> inside
import Checkout from "./components/Checkout";
import Dashboard from "./components/Dashboard";
import Lessons from "./components/Lessons";
import PaymentSuccess from "./components/Payment-Success";
import PaymentFailure from "./components/Payment-Failure";

export default function App() {
  // Works in both Vite and CRA environments
  const clientId =
    import.meta?.env?.VITE_GOOGLE_CLIENT_ID ||
    process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/signin" element={<SignIn />} />

            <Route path="/checkout" element={<Checkout />} />
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failure" element={<PaymentFailure />} />

            {/* protected lesson pages */}
            <Route
              path="/lessons"
              element={
                <ProtectedRoute>
                  <Lessons />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}
